/**
 * Categorías de auditoría agrupadas por scope (decisión 29). Los tres
 * scopes alimentan los 3 tabs de "cambios" (operaciones / accesos /
 * cambios admin) · el 4to tab (documentos) usa su propio endpoint y
 * no aparece acá.
 */
export const CATEGORIAS_OPERACIONES = [
  "Solicitud",
  "Prorrateo",
  "Cfdi",
  "Documento",
  "FlujoAutorizacion",
  "Poliza",
] as const;

export const CATEGORIAS_ADMIN = [
  "Organizacion",
  "Proveedor",
  "Area",
  "Usuario",
  "NivelAutorizacion",
  "SatOverride",
] as const;

export type AuditoriaScope = "operaciones" | "admin" | "accesos";

export function categoriasParaScope(scope: AuditoriaScope): readonly string[] {
  if (scope === "operaciones") return CATEGORIAS_OPERACIONES;
  if (scope === "admin") return CATEGORIAS_ADMIN;
  return ["Acceso"];
}
